import {
  MATERIAL_CONSULTATION_EMAIL_BODY,
  MATERIAL_CONSULTATION_EMAIL_SUBJECT,
} from "#modules/quoteRequests/domain/materialConsultationEmailTemplate";

export const buildExportConsultationMail = (userName: string, companyName?: string) => {
  const subject = MATERIAL_CONSULTATION_EMAIL_SUBJECT;
  let body = MATERIAL_CONSULTATION_EMAIL_BODY.replace(/\n/g, "\r\n");

  if (userName && companyName) {
    body = body
      .replace("[Nom]", userName)
      .replace("[Société]", companyName)
      .replace("[Fonction]\r\n", "")
      .replace("[Téléphone]", "");
  }

  return {
    subject,
    body,
  };
};
